var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import * as RadixDialog from "@radix-ui/react-dialog";
var DialogRoot = function (_a) {
    var children = _a.children, otherProps = __rest(_a, ["children"]);
    return _jsx(RadixDialog.Root, __assign({}, otherProps, { children: children }));
};
var DialogTrigger = function (_a) {
    var children = _a.children, otherProps = __rest(_a, ["children"]);
    return (_jsx(RadixDialog.Trigger, __assign({}, otherProps, { children: children })));
};
var DialogOverlay = function (_a) {
    var children = _a.children, otherProps = __rest(_a, ["children"]);
    return (_jsx(RadixDialog.Overlay, __assign({}, otherProps, { children: children })));
};
var DialogContent = function (_a) {
    var children = _a.children, otherProps = __rest(_a, ["children"]);
    return (_jsx(RadixDialog.Content, __assign({}, otherProps, { children: children })));
};
var DialogDescription = function (_a) {
    var children = _a.children, otherProps = __rest(_a, ["children"]);
    return (_jsx(RadixDialog.Description, __assign({}, otherProps, { children: children })));
};
var DialogTitle = function (_a) {
    var children = _a.children, otherProps = __rest(_a, ["children"]);
    return _jsx(RadixDialog.Title, __assign({}, otherProps, { children: children }));
};
var DialogClose = function (_a) {
    var children = _a.children, otherProps = __rest(_a, ["children"]);
    return _jsx(RadixDialog.Close, __assign({}, otherProps, { children: children }));
};
export { DialogRoot, DialogTrigger, DialogOverlay, DialogContent, DialogTitle, DialogDescription, DialogClose, };
